import { writable } from 'svelte/store'

export const panesStore = writable<Record<string, boolean>>({})
